import { BatchJobStatus } from '../../../domain/invoicing/invoicingApi'

export type BatchJobRow = {
  rowType: 'job'
  key: string
  job: BatchJobStatus
  isChild: boolean
}

export type BatchStatementRow = {
  rowType: 'statement'
  key: string
  statementId: string
  customerName: string
  jobCount: number
  children: BatchJobRow[]
}

export type BatchJobListRow = BatchJobRow | BatchStatementRow

export const groupBatchJobsByStatement = (jobs: BatchJobStatus[]): BatchJobListRow[] => {
  const rows: BatchJobListRow[] = []
  const statementRowsById = new Map<string, BatchStatementRow>()

  jobs.forEach(job => {
    if (!job.statementId) {
      rows.push({ rowType: 'job', key: job.id, job, isChild: false })
      return
    }

    let statementRow = statementRowsById.get(job.statementId)
    if (!statementRow) {
      statementRow = {
        rowType: 'statement',
        key: `statement-${job.statementId}`,
        statementId: job.statementId,
        customerName: job.customerName,
        jobCount: 0,
        children: []
      }
      statementRowsById.set(job.statementId, statementRow)
      rows.push(statementRow)
    }
    statementRow.children.push({ rowType: 'job', key: job.id, job, isChild: true })
    statementRow.jobCount = statementRow.children.length
  })

  return rows
}

export const statementRowKeys = (rows: BatchJobListRow[]): string[] =>
  rows.filter((row): row is BatchStatementRow => row.rowType === 'statement').map(row => row.key)
